<template>
  <div class="pa-4">
    <div v-if="!survey.released && $auth.policies['update-survey']" class="d-flex justify-end align-center mb-4">
      <v-btn outlined color="#0D47A1" @click="$refs.questionDialog.openDialog('create')">
        <v-icon left>add</v-icon>Thêm câu hỏi
      </v-btn>
    </div>
    <div>
      <QuestionView
        class="my-2"
        v-for="(question, index) in questions"
        :key="question.id"
        :index="index + 1"
        :question="question"
        :showAction="!survey.released"
      />
    </div>
    <QuestionDialog ref="questionDialog" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import QuestionView from './QuestionView.vue'
import QuestionDialog from '../../../modules/survey/survey-detail/QuestionDialog.vue'
export default {
  components: { QuestionView, QuestionDialog },
  computed: {
    ...mapState({
      questions: state => state.surveyQuestion.items,
      survey: state => state.survey.item
    })
  },
  mounted() {
    this.fetch({ survey: this.$route.params.id })
  },
  methods: {
    ...mapActions({
      fetch: 'surveyQuestion/fetch'
    })
  }
}
</script>

<style></style>
